import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * DropdownTrigger - A wrapper that renders a standard HTML div with Bulma class names
 *
 * This component accepts the same props as Bloomer DropdownTrigger for easy migration
 */
const DropdownTrigger = ({ className, children, style, onClick, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    return classNames('dropdown-trigger', {
      [className]: className,
    });
  };

  return (
    <div className={getClassNames()} style={style} onClick={onClick} {...props}>
      {children}
    </div>
  );
};

DropdownTrigger.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

DropdownTrigger.defaultProps = {
  className: '',
  style: {},
  children: null,
  onClick: null,
};

export default DropdownTrigger;
